import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AtypicalPriceReportRequest {
  fechaInicial: string;
  fechaFinal: string;
  porcentajeVariacion: number;
  segUsuario: number;
}

export interface AtypicalPriceReportResponse {
  columns: string[];
  payload: Array<Record<string, unknown>>;
  total: number;
}

@Injectable({ providedIn: 'root' })
export class AtypicalPriceReportService {
  private readonly endpoint = `${environment.apiUrl}/api/reportes/precios-atipicos`;

  constructor(private readonly http: HttpClient) {}

  getReport(request: AtypicalPriceReportRequest): Observable<AtypicalPriceReportResponse> {
    return this.http.post<AtypicalPriceReportResponse>(this.endpoint, request);
  }
}
